export default __webpack_public_path__ + "static/media/008-twitter.0b266e81.svg";